/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LedgerSearchResult { 
    groupName?: string | null;
    groupCode?: string | null;
    type?: string | null;
    ledgerName?: string | null;
    ledgerCode?: string | null;
    ledgerClosingBalance?: string | null;
    ledgerAmount?: string | null;
    accountNumber?: string | null;
    openingbalance?: string | null;
}

